// extracted by css-extract-rspack-plugin
export default {"PageLayout":"settings-view-module__PageLayout__zy5bW","Pane":"settings-view-module__Pane__Oct40","Content":"settings-view-module__Content__TPxSN"};